function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-card--featured-image-link .product-primary-image');
      this.image_hover = this.querySelector('.product-card--featured-image-link .product-secondary-image');
      this.additional_images = this.querySelectorAll('.product-card--featured-image-link .product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-card--featured-image-link .product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.product_title = this.querySelector('.product-card-title');
      this.image_link = this.querySelector('.product-card--featured-image-link');
      this.image_links = this.querySelectorAll('.product-card--featured-image-link');
      this.defaultProductId = this.dataset.productId;
      this.size_groups = Array.from(this.querySelectorAll('.product-card-sizes'));
      this.size_containers = Array.from(this.querySelectorAll('.product-card-sizes--container'));
      this.badge_containers = Array.from(this.querySelectorAll('.product-card--badges'));
      this.price_containers = Array.from(this.querySelectorAll('.product-card-price'));
      this.groupState = new WeakMap();
    }
    connectedCallback() {

      // Ensure this card has a unique selector Swym can query
      if (!this.id) {
        this.id = `product-card-${this.defaultProductId || Math.random().toString(36).slice(2)}`;
      }
      this._swymScopeSel = `#${this.id}`;


      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image, this.image_hover);
        // set initial visibility based on the active swatch
        const active = this.swatches.querySelector('.product-card-swatch.active, .product-card-swatch--current');
        const initialColor = active ? this.extractColorFromSwatch(active) : null;
        if (initialColor) this.showSizesForColor(initialColor);
        if (this.defaultProductId) this.showBadgesById(this.defaultProductId);
        if (this.defaultProductId) this.showPriceById(this.defaultProductId);
      }
      if (this.additional_images) this.enableAdditionalImages();
      if (this.quick_add) this.enableQuickAdd();
      if (this.size_groups.length) this.size_groups.forEach((group) => this.enableSizeOptions(group));

    }
    extractColorFromSwatch(swatch) {
      // 1) preferred: inner <span>
      const spanTxt = swatch.querySelector('span')?.innerText?.trim();
      if (spanTxt) return spanTxt.toUpperCase();

      // 2) background-image url(.../oyster.png)
      const bg = swatch.getAttribute('style') || '';
      const mBg = bg.match(/background-image:\s*url\(([^)]+)\)/i);
      if (mBg && mBg[1]) {
        const file = mBg[1].split('/').pop() || '';
        const name = file.split('.')[0];
        if (name) return name.replace(/[-_]/g, ' ').trim().toUpperCase();
      }

      // 3) data-href slug fallback
      const href = swatch.dataset.href || '';
      const mHref = href.match(/[-\/]([a-z0-9]+)(?:\?|$)/i);
      if (mHref && mHref[1]) return mHref[1].replace(/[-_]/g, ' ').toUpperCase();

      return '';
    }
    showSizesForColor(colorUpper) {
      this.size_containers.forEach((container) => {
        const group = container.querySelector('.product-card-sizes');
        const groupColor = (group?.dataset?.options || '').split(',')[0].trim().toUpperCase();
        container.style.display = groupColor === colorUpper ? '' : 'none';
      });
    }
    showBadgesById(id) {
      this.badge_containers.forEach((container) => {
        container.style.display = container?.dataset?.productId === id ? '' : 'none';
      });
    }
    showPriceById(id) {
      // Toggle a class on the wrapper rather than inline display on the price: Regios Discounts un-hides the prices it updates
      this.price_containers.forEach((container) => {
        container.classList.toggle('product-card-price--hidden', container?.dataset?.productId !== id);
      });
    }
    enableAdditionalImages() {
      this.image_links.forEach((imageLink) => {
        const productId = imageLink.dataset.imagesProductId;

        const images = Array.from(imageLink.querySelectorAll('img'));
        const image_length = images.length;

        if (!image_length) return;

        const prevButton = this.querySelector(`.product-secondary-images-nav_prev[data-arrow-product-id="${productId}"]`);
        const nextButton = this.querySelector(`.product-secondary-images-nav_next[data-arrow-product-id="${productId}"]`);

        let currentIndex = 0;

        const setActiveImage = (index) => {
          if (!image_length) return;

          if (index < 0) index = image_length - 1;
          if (index >= image_length) index = 0;

          images.forEach((image) => {
            image.classList.remove('hover');
          });

          const activeImage = images[index];
          if (activeImage) {
            activeImage.classList.add('hover');
            currentIndex = index;
          }
        };

        setActiveImage(0);

        if (prevButton) {
          prevButton.addEventListener('click', (e) => {
            e.stopPropagation()
            setActiveImage(currentIndex - 1);
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', (e) => {
            e.stopPropagation()
            setActiveImage(currentIndex + 1);
          });
        }

        // Show the first secondary image on hover and reset on leave. Listen on the figure
        // (not the link) so moving onto the prev/next arrows doesn't count as leaving.
        const hoverArea = imageLink.closest('.product-card--featured-image');
        if (hoverArea && image_length > 1 && window.matchMedia('(hover: hover)').matches) {
          hoverArea.addEventListener('mouseenter', () => {
            if (currentIndex === 0) setActiveImage(1);
          });

          hoverArea.addEventListener('mouseleave', () => {
            setActiveImage(0);
          });
        }

        images.forEach((image) => {
          window.addEventListener('load', () => lazySizes.loader.unveil(image));
        });
      });
    }
    enableSwatches(swatches, image, image_hover) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';
      this.color_index = this.swatches.dataset.index;

      swatch_list.forEach((swatch) => {
        window.addEventListener('load', () => {
          let img = new Image();
          img.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(img);
        });

        swatch.addEventListener('click', (evt) => {
          evt.preventDefault();
          // visual state
          swatch_list.forEach((el) => el.classList.remove('active'));
          swatch.classList.add('active');

          // swap wishlist widget
          const wishLists = this.querySelectorAll('.swym-button.swym-add-to-wishlist-view-product');
          const singleWishList = this.querySelector(
            `.swym-button.swym-add-to-wishlist-view-product[data-product-id="${swatch.dataset.productId}"]`
          );

          if (wishLists.length > 0 || singleWishList) {
            wishLists.forEach((list) => {
              list.style.display = 'none';
            });
            if (singleWishList) {
              singleWishList.style.display = 'flex';
            }
          }
          

          // swap image
          if (image) {
            if (swatch.dataset.srcset) image.setAttribute('srcset', swatch.dataset.srcset);
            else image.setAttribute('srcset', org_srcset);
          }

          // swap secondary image
          if (image && image_hover) {
            if (swatch.dataset.srcsetHover) image_hover.setAttribute('srcset', swatch.dataset.srcsetHover);
            else image_hover.setAttribute('srcset', org_srcset);
          }

          // show matching size container
          const color = this.extractColorFromSwatch(swatch);
          if (color) this.showSizesForColor(color);
          if (swatch.dataset.productId) this.showBadgesById(swatch.dataset.productId);
          if (swatch.dataset.productId) this.showPriceById(swatch.dataset.productId);
          if (swatch.dataset.href) {
            this.image_link.setAttribute('href', swatch.dataset.href);
            this.product_title.setAttribute('href', swatch.dataset.href);
          }

          // swap color label
          const colorLabel = this.querySelector('.product-card-color-label');
          if (colorLabel && swatch.dataset.color) {
            colorLabel.textContent = swatch.dataset.color.toLowerCase();
          }

          // swap product rating widget
          const productRatings = this.querySelectorAll('.product-star-ratings > div');
          const singleProductRating = this.querySelector(
            `.product-star-ratings .yotpo-widget-instance[data-yotpo-product-id="${swatch.dataset.productId}"]`
          );

          if (productRatings.length > 0 || singleProductRating) {
            productRatings.forEach((rating) => {
              rating.style.display = 'none';
            });
            if (singleProductRating) {
              singleProductRating.style.display = 'block';
            }
          }

          // swap image sets
          const productImagesLinks = this.querySelectorAll('.product-card--featured-image-link');
          const productImagesLink = this.querySelector(
            `.product-card--featured-image-link[data-images-product-id="${swatch.dataset.productId}"]`
          );

          if (productImagesLinks.length > 0 || productImagesLink) {
            productImagesLinks.forEach((link) => {
              link.style.display = 'none';
            });
            if (productImagesLink) {
              productImagesLink.style.display = 'block';
            }
          }

          const productImagesButtons = this.querySelectorAll('.product-secondary-images-nav');
          const productImagesButton = this.querySelectorAll(
            `.product-secondary-images-nav[data-arrow-product-id="${swatch.dataset.productId}"]`
          );

          if (productImagesButtons.length > 0 || productImagesButton.length > 0) {
            productImagesButtons.forEach((button) => {
              button.style.display = 'none';
            });
            if (productImagesButton.length > 0) {
              productImagesButton.forEach((button) => {
                button.style.display = 'flex';
              });
            }
          }

          // swap product subtitle
          const productSubtitles = this.querySelectorAll('.product-subtitle > span');
          const singleProductSubtitle = this.querySelector(
            `.product-subtitle span[data-product-id="${swatch.dataset.productId}"]`
          );

          if (productSubtitles.length > 0 || singleProductSubtitle) {
            productSubtitles.forEach((title) => {
              title.style.display = 'none';
            });
            if (singleProductSubtitle) {
              singleProductSubtitle.style.display = 'block';
            }
          }

        });

      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    enableSizeOptions(size_options) {
      let size_list = size_options.querySelectorAll('.product-card-sizes--size'),
        featured_image = this.querySelector('.product-card--featured-image'),
        has_hover = featured_image.classList.contains('thb-hover'),
        size_parent = size_options.parentElement;

      const size_index = Number(size_options.dataset.index);
      const current_options = size_options.dataset.options.split(',');
      const variantData = this.getVariantDataFor(size_options);

      const state = {
        size_options,
        size_list,
        size_index,
        current_options,
        variantData,
        currentVariant: null
      };
      this.groupState.set(size_options, state);

      const updateMasterIdFor = () => {
        state.currentVariant = (state.variantData || []).find((variant) => {
          return !variant.options.map((option, index) => state.current_options[index] === option).includes(false);
        }) || null;
        setTimeout(() => setDisabledFor(), 100);
      };

      const createAvailableOptionsTree = (variant_data, selected_options) => {
        return variant_data.reduce((options, variant) => {
          Object.keys(options).forEach(index => {
            if (variant[index] === null) return;
            let entry = options[index].find(option => option.value === variant[index]);
            if (!entry) {
              entry = { value: variant[index], isUnavailable: true };
              options[index].push(entry);
            }
            const countMatch = selected_options.reduce((count, { value, index }) => (variant[index] === value ? count + 1 : count), 0);
            if (countMatch >= selected_options.length - 1) {
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
            }
            if ((!state.currentVariant || !state.currentVariant.available) && selected_options.find((o) => o.value === entry.value && index === o.index)) {
              entry.isUnavailable = true;
            }
            if (index === 'option1') {
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
            }
          });
          return options;
        }, { option1: [], option2: [], option3: [] });
      };

      const setDisabledFor = () => {
        const variant_data = state.variantData;
        if (!variant_data) return true;

        if (state.currentVariant) {
          const selected_options = state.currentVariant.options.map((value, index) => ({ value, index: `option${index + 1}` }));
          const available_options = createAvailableOptionsTree(variant_data, selected_options);
          const fieldset_options = Object.values(available_options)[state.size_index];
          if (fieldset_options && state.size_list.length) {
            state.size_list.forEach((input, i) => {
              input.classList.toggle('is-disabled', fieldset_options[i]?.isUnavailable);
            });
          }
        } else {
          if (state.size_list.length) {
            state.size_list.forEach((input) => input.classList.add('is-disabled'));
          }
        }
        return true;
      };

      updateMasterIdFor();

      size_parent.addEventListener('mouseenter', () => { if (has_hover) featured_image.classList.remove('thb-hover'); }, { passive: true });
      size_parent.addEventListener('mouseleave', () => { if (has_hover) featured_image.classList.add('thb-hover'); }, { passive: true });

      state.size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();
          if (size.classList.contains('is-disabled')) return;

          state.current_options[state.size_index] = size.querySelector('span').innerText;
          updateMasterIdFor();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);

          const config = {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }
          };
          let formData = new FormData();
          formData.append('id', state.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((s) => s.section));
          formData.append('sections_url', window.location.pathname);
          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((r) => r.json())
            .then((r) => {
              if (r.status) return;
              this.renderContents(r);
              dispatchCustomEvent('cart:item-added', { product: r.hasOwnProperty('items') ? r.items[0] : r });
            })
            .catch(console.error)
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });
    }
    getVariantDataFor(size_options) {
      let script = size_options.nextElementSibling;
      while (script && !(script.tagName === 'SCRIPT' && script.type === 'application/json')) {
        script = script.nextElementSibling;
      }
      try {
        if (script) return JSON.parse(script.textContent);
      } catch (e) {
        console.error('Variant JSON parse error', e);
      }
      const fallback = this.querySelector('script[type="application/json"]');
      return fallback ? JSON.parse(fallback.textContent) : [];
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) return;

      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }
      };
      let formData = new FormData();
      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((s) => s.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((r) => r.json())
        .then((r) => {
          if (r.status) return;
          this.renderContents(r);
          dispatchCustomEvent('cart:item-added', { product: r.hasOwnProperty('items') ? r.items[0] : r });
        })
        .catch(console.error)
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [
        { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
        { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
      ];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) return;
        const el = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        el.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }
        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));

      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart', 'open-cc');
        document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')?.classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}



/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');

      this.onClick = (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      };
      // Add functionality to buttons
      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('panel:close', this.onClick.bind(this));
      if (!this.cc.hasAttribute('initialized')) {
        this.cc.addEventListener('click', this.onClick.bind(this));
        this.cc.setAttribute('initialized', '');
      }

    }
    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel.active');

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains('product-drawer') || document.body.classList.contains('open-quick-view')) {
        this.close_quick_view();
      } else if (panel.classList.contains('cart-drawer')) {
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                panel.classList.remove('active');
                document.body.classList.remove('open-cc');
                document.body.classList.remove('open-cart');
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          }
        }
      } else {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    }
    close_quick_view() {
      let panel = document.getElementById('Product-Drawer');

      if (panel.querySelector('.product-quick-images--container')) {
        panel.querySelector('.product-quick-images--container').classList.remove('active');
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove('active');
        if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
      } else {
        if (panel.querySelector('.product-quick-images--container')) {
          setTimeout(() => {
            panel.classList.remove('active');
            if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
              document.body.classList.remove('open-cc');
            }
            document.body.classList.remove('open-quick-view');
            panel.querySelector('#Product-Drawer-Content').innerHTML = '';
          }, 500);
        }
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      let button = document.getElementById('cart-drawer-toggle');

      // Add functionality to buttons
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        this.classList.add('active');
        this.focus();
        setTimeout(() => {
          this.querySelector('.product-recommendations--full')?.classList.add('active');
        });
        dispatchCustomEvent('cart-drawer:open');
      });

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.notesToggle();
      this.removeProductEvent();
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {
      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.target.dataset.index, '0');

          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    notesToggle() {
      const notes_toggle = document.getElementById('order-note-toggle');

      if (!notes_toggle) {
        return;
      }

      notes_toggle.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.add('active');
      });
      notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
        el.addEventListener('click', (event) => {
          notes_toggle.nextElementSibling.classList.remove('active');
          this.saveNotes();
        });
      });
    }
    saveNotes() {
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': document.getElementById('mini-cart__notes').value
        })
      });
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      this.querySelector('.product-recommendations--full')?.classList.remove('active');

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          this.removeProductEvent();
          this.notesToggle();
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });

          this.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
        });
    }
    refresh() {
      this.querySelector('.product-recommendations--full')?.classList.remove('active');
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
          this.notesToggle();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add('open-cc');
        this.body.classList.add('open-quick-view');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          this.drawer.querySelector('.product-quick-images--container').classList.add('active');
        });
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});

(() => {
  function initColorSwatchTooltips() {
    const swatches = document.querySelectorAll('.facet--color-swatch');
    if (!swatches.length) return;

    let tooltip = document.querySelector('.facet-tooltip');
    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.className = 'facet-tooltip';
      document.body.appendChild(tooltip);
    }

    swatches.forEach((swatch) => {
      // Prevent duplicate listeners
      if (swatch.dataset.tooltipBound) return;
      swatch.dataset.tooltipBound = true;

      swatch.addEventListener('mouseenter', (e) => {
        const text = swatch.getAttribute('data-tooltip');
        if (!text) return;
        tooltip.textContent = text;
        tooltip.classList.add('active');
        positionTooltip(e);
      });

      swatch.addEventListener('mousemove', (e) => {
        positionTooltip(e);
      });

      swatch.addEventListener('mouseleave', () => {
        tooltip.classList.remove('active');
      });
    });

    function positionTooltip(e) {
      const offset = 10;
      tooltip.style.left = `${e.pageX + offset}px`;
      tooltip.style.top = `${e.pageY + offset}px`;
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorSwatchTooltips, { once: true });
  } else {
    initColorSwatchTooltips();
  }

  // Allow re-init externally
  document.addEventListener('facet-tooltips:init', () => {
    initColorSwatchTooltips();
  });
})();
